$("a[data-location]").on("click", (e) => {
	const location = $(e.target).data("location");

	window.location.href = `${homeUrl}/contact-us#${location.toLowerCase()}`;
});

if ($("body").hasClass("page-id-505")) {
	if (location.href.indexOf("#leeds") != -1) {
		$("#leeds").addClass("open");
		$("#leeds .button").focus();
	} else if (location.href.indexOf("#london") != -1) {
		$("#london").addClass("open");
		$("#london .button").focus();
	} else if (location.href.indexOf("#manchester") != -1) {
		$("#manchester").addClass("open");
		$("#manchester .button").focus();
	} else {
	}
}
